import React from 'react';
import { ShieldCheck, Lock, Clock } from 'lucide-react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { useLanguage } from '../hooks/useLanguage';
export function FinalCTASection() {
  const {
    t
  } = useLanguage();
  return <Section background="stone" id="pricing" className="py-24" data-id="element-36">
      <div className="max-w-4xl mx-auto bg-gradient-to-br from-[#0F0B2E] via-[#1E1B4B] to-[#312E81] border border-purple-800/50 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden text-center" data-id="element-37">
        {/* Glow Effect */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-brand-amber/5 blur-[100px] pointer-events-none" data-id="element-38"></div>

        <h2 className="text-4xl md:text-6xl font-heading font-bold text-white mb-6 relative z-10" data-id="element-39">
          {t('cta', 'title')}
        </h2>

        <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto relative z-10" data-id="element-40">
          {t('cta', 'desc1')}
          <span className="text-brand-amber font-bold" data-id="element-41">
            {t('cta', 'desc2')}
          </span>
          {t('cta', 'desc3')}
          <span className="text-brand-amber font-bold" data-id="element-42">
            {t('cta', 'desc4')}
          </span>
          {t('cta', 'desc5')}
        </p>

        {/* Product Bundle Image */}
        <div className="mb-10 relative z-10" data-id="element-43">
          <img src={t('cta', 'bundleImage')} alt="Guía de Voice Over + 3 Bonos Exclusivos" className="mx-auto w-full h-auto rounded-xl shadow-2xl shadow-black/40" data-id="element-44" />
        </div>

        <div className="flex flex-col items-center justify-center mb-10 relative z-10" data-id="element-45">
          <div className="text-blue-300 text-lg line-through mb-2" data-id="element-46">
            {t('cta', 'priceNormal')}
          </div>
          <div className="text-6xl md:text-8xl font-heading font-bold text-white mb-2 flex items-start" data-id="element-47">
            <span className="text-4xl mt-2" data-id="element-48">$</span>14.97
          </div>
          <div className="bg-brand-fire/20 text-purple-300 border border-brand-fire/50 px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider animate-pulse" data-id="element-49">
            {t('cta', 'offer')}
          </div>
        </div>

        <a href={t('hero', 'ctaLink')} target="_blank" rel="noopener noreferrer" className="block max-w-md mx-auto mb-4 relative z-10" data-id="element-50">
          <Button variant="primary" size="xl" fullWidth glow withIcon data-id="element-51">
            {t('cta', 'btn')}
          </Button>
        </a>

        <p className="text-blue-100 text-base md:text-lg max-w-lg mx-auto mb-6 relative z-10 leading-relaxed italic" data-id="element-52">
          {t('cta', 'personalMsg')}
        </p>

        <a href={t('cta', 'consultaLink')} target="_blank" rel="noopener noreferrer" className="block max-w-md mx-auto mb-8 relative z-10" data-id="element-53">
          <button className="w-full px-6 py-4 rounded-xl border-2 border-white/30 bg-white/10 backdrop-blur-sm text-white font-bold text-lg hover:bg-white/20 transition-all duration-300" data-id="element-54">
            {t('cta', 'consultaBtn')}
          </button>
        </a>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-blue-200 border-t border-white/10 pt-8 relative z-10" data-id="element-55">
          <div className="flex flex-col items-center gap-2" data-id="element-56">
            <ShieldCheck className="w-8 h-8 text-brand-amber" data-id="element-57" />
            <span className="font-semibold text-white" data-id="element-58">
              {t('cta', 'f1Title')}
            </span>
            <span data-id="element-59">{t('cta', 'f1Desc')}</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-60">
            <Lock className="w-8 h-8 text-brand-amber" data-id="element-61" />
            <span className="font-semibold text-white" data-id="element-62">
              {t('cta', 'f2Title')}
            </span>
            <span data-id="element-63">{t('cta', 'f2Desc')}</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-64">
            <Clock className="w-8 h-8 text-brand-amber" data-id="element-65" />
            <span className="font-semibold text-white" data-id="element-66">
              {t('cta', 'f3Title')}
            </span>
            <span data-id="element-67">{t('cta', 'f3Desc')}</span>
          </div>
        </div>
      </div>
    </Section>;
}